/* StudioSoie · Chat du AI Solver — widget v2.2 thème (streaming des réponses) (source : maquette « Chat StudioSoie », 2 sept.).
   Un seul code pour la démo (transport "demo", réponses simulées) et la production (transport "http" → passerelle Cloudflare Worker).
   Configuration : window.SS_CHAT_CONFIG (émis par sections/ss-chat-solver.liquid) ; textes : window.SS_CHAT_I18N (locale courante, émis par la section
   depuis locales/*.json, clés ss_chat.*) avec repli anglais embarqué ci-dessous. Dépend de ss-chat.css. */
(function () {
  'use strict';

  /* Textes embarqués : anglais (repli universel) et français (langue principale de la boutique).
     La section émet le dictionnaire de la langue courante depuis locales/*.json ; quand Shopify n'a pas de traduction,
     il renvoie le français : ces valeurs identiques au français sont ignorées et l'anglais prend le relais. */
  var EN = {
    "launcher": "Need help?",
    "title": "StudioSoie",
    "subtitle": "Customer care · answers in seconds",
    "greeting": "Hello, how can we help you?",
    "door_order_t": "My order",
    "door_order_d": "Tracking, address, cancellation",
    "door_problem_t": "A problem",
    "door_problem_d": "Damaged item, sizing, return — instant solution",
    "door_question_t": "A question",
    "door_question_d": "Silks, sizes, care, delivery",
    "order_prompt": "Let's find your order.",
    "order_label": "Order number",
    "order_ph": "STUDS-12345",
    "email_label": "E-mail used for the order",
    "email_ph": "you@example.com",
    "continue": "Continue",
    "back": "Back",
    "send": "Send",
    "close": "Close",
    "home": "Menu",
    "verifying": "Checking…",
    "order_notfound": "We can't find this order with this e-mail. Check the number (format STUDS-12345) and the address used at checkout.",
    "order_found": "Order found.",
    "status_unfulfilled": "Being prepared",
    "status_intransit": "In transit",
    "status_delivered": "Delivered",
    "status_fulfilled": "Shipped",
    "status_cancelled": "Cancelled",
    "placed_on": "Placed on",
    "items": "Items",
    "total": "Total",
    "tracking": "Tracking",
    "eta": "Estimated delivery",
    "eta_fr": "4 to 7 business days",
    "eta_eu": "5 to 8 business days",
    "eta_intl": "7 to 12 business days",
    "track_link": "Track my parcel",
    "act_where": "Where is my parcel?",
    "act_address": "Change the address",
    "act_cancel": "Cancel the order",
    "act_problem": "A problem with an item",
    "act_other": "Another question",
    "where_unfulfilled": "Your order is being prepared in our workshop. You'll receive the tracking number by e-mail as soon as it ships.",
    "where_transit": "Your parcel is on its way. Latest status: {status}. Estimated delivery: {eta}.",
    "where_delivered": "Your parcel is marked as delivered. If you haven't received it, tell us: we open an investigation right away.",
    "not_received": "I haven't received it",
    "not_received_reply": "We're opening an investigation with the carrier. Meanwhile, please check with neighbours, the concierge or the pickup point shown. With no news within 5 business days, we resend the item or refund you in full.",
    "address_prompt": "Please type the full new address (street, postcode, city, country).",
    "address_ok": "Address updated. Your order will ship to the new address.",
    "address_late": "Your order has already shipped, so the address can no longer be changed. If the parcel comes back to us, we reship it at no cost.",
    "cancel_ask": "Your order hasn't shipped yet: we can cancel it and refund you in full. Do you confirm the cancellation?",
    "cancel_yes": "Yes, cancel",
    "cancel_no": "No, keep it",
    "cancel_done": "Done. The refund will appear within 3 to 5 business days depending on your bank.",
    "cancel_kept": "Very well, your order stays as it is.",
    "cancel_late": "Your order has already shipped. You can refuse it on delivery or use our Returns & Solutions area once received.",
    "address_pending": "Request received. We'll confirm the update by e-mail within 24 hours.",
    "cancel_pending": "Cancellation request received. We'll confirm by e-mail within 24 hours; the refund follows right away.",
    "problem_item": "Which item is concerned?",
    "problem_reason": "What is the reason?",
    "r_size_small": "Too small",
    "r_size_big": "Too big",
    "r_not_liked": "I don't like it",
    "r_quality": "Quality below my expectations",
    "r_damaged": "Item damaged on arrival",
    "r_not_as_described": "Not as described",
    "r_wrong_item": "Wrong item received",
    "r_missing": "Missing item",
    "r_other": "Other",
    "intimates_notice": "For hygiene reasons, intimate items (briefs, lingerie bottoms, worn bodysuits) cannot be returned or refunded.",
    "offer_title": "Good news: no need to send your parcel back.",
    "offer_sub": "Keep your item or gift it, and pick the instant solution that suits you.",
    "offer2_title": "Our best offer, before you ship anything.",
    "offer2_sub": "A return takes 2 to 3 weeks, shipping at your cost. These solutions are immediate:",
    "best": "Best value",
    "credit_title": "Instant store credit",
    "credit_line": "{pct}% of the item price, i.e. {amount}",
    "credit_pts": "Nothing to send back · no minimum · stackable",
    "cash_title": "Partial refund",
    "cash_line": "{pct}% of the price, i.e. {amount}",
    "cash_pts": "Nothing to send back · within 3 to 5 business days",
    "choose": "I choose this solution",
    "keep_return": "I'd rather return the item",
    "credit_done": "Your {amount} credit is ready. Code: {code} — we're e-mailing it to you as well. Thank you for your trust.",
    "credit_pending": "Noted. Your {amount} credit will reach you by e-mail within 24 hours, with its code.",
    "cash_done": "Noted. The {amount} refund will appear within 3 to 5 business days depending on your bank.",
    "return_title": "Return request",
    "return_warn": "Return shipping at your cost, except for damaged or non-conforming items. Refund within 14 days of receipt and inspection.",
    "photos_intro": "Three photos are required: the product, the original packaging and the shipping label.",
    "photo_product": "Product photo",
    "photo_packaging": "Packaging photo",
    "photo_label": "Shipping label photo",
    "add_photo": "Add",
    "photos_missing": "Please add all three photos.",
    "damaged_title": "We're sorry — let's fix this right now.",
    "damaged_sub": "With your photos, we open your case immediately.",
    "damaged_sent": "Case opened. We'll be back within 24 to 48 hours with your solution: a new item free of charge, a {creditDmg}% credit or a {cashDmg}% refund, without returning the parcel.",
    "return_sent": "Request saved. You'll receive the next steps by e-mail within 24 hours.",
    "comment_label": "Details (optional)",
    "comment_ph": "Tell us more…",
    "question_prompt": "Ask your question, we answer in your language.",
    "q_delivery": "Delivery times",
    "q_care": "Silk care",
    "q_sizes": "Size guide",
    "q_momme": "16, 19 or 22 momme?",
    "input_ph": "Write your message…",
    "email_fallback": "Continue by e-mail",
    "email_prompt": "Leave us your e-mail: we'll continue in writing, in your language.",
    "email_done": "Thank you. You'll receive our reply at {email} within 24 business hours.",
    "typing": "StudioSoie is typing…",
    "error": "A small connection hiccup. Try again, or write to us at support@studiosoie.com.",
    "footer": "Instant answers · 7 days a week",
    "demo_badge": "Mock-up · simulated replies",
    "a_delivery": "France: 4 to 7 business days. European Union: 5 to 8 business days. Rest of the world: 7 to 12 business days. The tracking number is e-mailed as soon as your order ships.",
    "a_care": "Hand wash or machine wash at 30 °C on a delicate cycle, in a mesh bag, with a silk-specific detergent. No tumble dryer: dry flat, away from direct sun. Iron gently on the reverse while slightly damp.",
    "a_sizes": "Pillowcases: 50×70 and 65×65 cm. Duvet covers: 140×200, 200×200, 240×220 cm. For garments, each product page lists flat measurements; between two sizes, choose the larger for a fluid drape.",
    "a_momme": "Momme measures silk density. 16 momme: light and airy. 19 momme: the balance of softness, hold and longevity — our reference. 22 momme: denser, heavier, with a deep lustre for exceptional bedding.",
    "a_generic": "Thank you for your question. I'll answer in a moment — and if you prefer, we can continue by e-mail to keep a written record.",
    "source_lang": "en"
  };
  var FR = {
    "launcher": "Besoin d'aide ?",
    "title": "StudioSoie",
    "subtitle": "Service client · réponse en quelques secondes",
    "greeting": "Bonjour, comment pouvons-nous vous aider ?",
    "door_order_t": "Ma commande",
    "door_order_d": "Suivi, adresse, annulation",
    "door_problem_t": "Un problème",
    "door_problem_d": "Article abîmé, taille, retour — solution immédiate",
    "door_question_t": "Une question",
    "door_question_d": "Soies, tailles, entretien, livraison",
    "order_prompt": "Retrouvons votre commande.",
    "order_label": "Numéro de commande",
    "order_ph": "STUDS-12345",
    "email_label": "E-mail utilisé pour la commande",
    "email_ph": "vous@exemple.com",
    "continue": "Continuer",
    "back": "Retour",
    "send": "Envoyer",
    "close": "Fermer",
    "home": "Menu",
    "verifying": "Vérification…",
    "order_notfound": "Nous ne trouvons pas cette commande avec cet e-mail. Vérifiez le numéro (format STUDS-12345) et l'adresse utilisée lors de l'achat.",
    "order_found": "Commande retrouvée.",
    "status_unfulfilled": "En préparation",
    "status_intransit": "En transit",
    "status_delivered": "Livrée",
    "status_fulfilled": "Expédiée",
    "status_cancelled": "Annulée",
    "placed_on": "Passée le",
    "items": "Articles",
    "total": "Total",
    "tracking": "Suivi",
    "eta": "Livraison estimée",
    "eta_fr": "4 à 7 jours ouvrés",
    "eta_eu": "5 à 8 jours ouvrés",
    "eta_intl": "7 à 12 jours ouvrés",
    "track_link": "Suivre mon colis",
    "act_where": "Où est mon colis ?",
    "act_address": "Modifier l'adresse",
    "act_cancel": "Annuler la commande",
    "act_problem": "Un problème avec un article",
    "act_other": "Autre question",
    "where_unfulfilled": "Votre commande est en cours de préparation dans nos ateliers. Vous recevrez le numéro de suivi par e-mail dès l'expédition.",
    "where_transit": "Votre colis est en route. Dernier statut : {status}. Livraison estimée : {eta}.",
    "where_delivered": "Votre colis est indiqué comme livré. Si vous ne l'avez pas reçu, dites-le-nous : nous lançons une enquête immédiatement.",
    "not_received": "Je ne l'ai pas reçu",
    "not_received_reply": "Nous ouvrons une enquête auprès du transporteur. Pendant ce temps, vérifiez auprès de vos voisins, du gardien ou du point relais indiqué. Sans nouvelle sous 5 jours ouvrés, nous vous renvoyons l'article ou vous remboursons intégralement.",
    "address_prompt": "Indiquez la nouvelle adresse complète (rue, code postal, ville, pays).",
    "address_ok": "Adresse mise à jour. Votre commande partira à cette nouvelle adresse.",
    "address_late": "Votre commande est déjà expédiée : l'adresse ne peut plus être modifiée. Si le colis nous revient, nous le réexpédions sans frais.",
    "cancel_ask": "Votre commande n'est pas encore expédiée : nous pouvons l'annuler et vous rembourser intégralement. Confirmez-vous l'annulation ?",
    "cancel_yes": "Oui, annuler",
    "cancel_no": "Non, je la garde",
    "cancel_done": "C'est fait. Le remboursement apparaîtra sous 3 à 5 jours ouvrés selon votre banque.",
    "cancel_kept": "Très bien, votre commande est maintenue.",
    "cancel_late": "Votre commande est déjà expédiée. Vous pourrez la refuser à la livraison ou utiliser notre espace Retours & Solutions dès réception.",
    "address_pending": "Demande transmise. Nous confirmons la mise à jour par e-mail sous 24 h.",
    "cancel_pending": "Demande d'annulation transmise. Nous confirmons par e-mail sous 24 h ; le remboursement suit immédiatement.",
    "problem_item": "Quel article est concerné ?",
    "problem_reason": "Quelle est la raison ?",
    "r_size_small": "Trop petit",
    "r_size_big": "Trop grand",
    "r_not_liked": "Ne me plaît pas",
    "r_quality": "Qualité en dessous de mes attentes",
    "r_damaged": "Article abîmé à la réception",
    "r_not_as_described": "Ne correspond pas à la description",
    "r_wrong_item": "Mauvais article reçu",
    "r_missing": "Article manquant",
    "r_other": "Autre",
    "intimates_notice": "Pour des raisons d'hygiène, les produits intimes (culottes, bas de lingerie, bodys portés) ne peuvent être ni retournés ni remboursés.",
    "offer_title": "Bonne nouvelle : pas besoin de renvoyer votre colis.",
    "offer_sub": "Gardez votre article ou offrez-le, et choisissez la solution immédiate qui vous convient.",
    "offer2_title": "Notre meilleure offre, avant l'envoi.",
    "offer2_sub": "Un retour prend 2 à 3 semaines, frais à votre charge. Ces solutions sont immédiates :",
    "best": "Le plus avantageux",
    "credit_title": "Avoir immédiat",
    "credit_line": "{pct} % du prix de l'article, soit {amount}",
    "credit_pts": "Rien à renvoyer · valable sans minimum · cumulable",
    "cash_title": "Remboursement partiel",
    "cash_line": "{pct} % du prix, soit {amount}",
    "cash_pts": "Rien à renvoyer · sous 3 à 5 jours ouvrés",
    "choose": "Je choisis cette solution",
    "keep_return": "Je préfère renvoyer l'article",
    "credit_done": "Votre avoir de {amount} est créé. Code : {code} — nous vous l'envoyons aussi par e-mail. Merci de votre confiance.",
    "credit_pending": "C'est noté. Votre avoir de {amount} vous parvient par e-mail sous 24 h, avec son code d'utilisation.",
    "cash_done": "C'est noté. Le remboursement de {amount} apparaîtra sous 3 à 5 jours ouvrés selon votre banque.",
    "return_title": "Demande de retour",
    "return_warn": "Frais de renvoi à votre charge, sauf article abîmé ou non conforme. Remboursement sous 14 jours après réception et contrôle.",
    "photos_intro": "Trois photos sont nécessaires : le produit, l'emballage d'origine et l'étiquette d'expédition.",
    "photo_product": "Photo du produit",
    "photo_packaging": "Photo de l'emballage",
    "photo_label": "Photo de l'étiquette",
    "add_photo": "Ajouter",
    "photos_missing": "Merci d'ajouter les trois photos.",
    "damaged_title": "Nous sommes désolés — réglons cela tout de suite.",
    "damaged_sub": "Avec vos photos, nous ouvrons votre dossier immédiatement.",
    "damaged_sent": "Dossier ouvert. Nous revenons vers vous sous 24 à 48 h avec la solution : nouvel article offert, avoir de {creditDmg} % ou remboursement de {cashDmg} %, sans renvoyer le colis.",
    "return_sent": "Demande enregistrée. Vous recevrez la marche à suivre par e-mail sous 24 h.",
    "comment_label": "Précisions (facultatif)",
    "comment_ph": "Dites-nous en plus…",
    "question_prompt": "Posez votre question, nous répondons dans votre langue.",
    "q_delivery": "Délais de livraison",
    "q_care": "Entretien de la soie",
    "q_sizes": "Guide des tailles",
    "q_momme": "16, 19 ou 22 momme ?",
    "input_ph": "Écrivez votre message…",
    "email_fallback": "Continuer par e-mail",
    "email_prompt": "Laissez-nous votre e-mail : nous poursuivons par écrit, dans votre langue.",
    "email_done": "Merci. Vous recevrez notre réponse à {email} sous 24 h ouvrées.",
    "typing": "StudioSoie écrit…",
    "error": "Un petit souci de connexion. Réessayez, ou écrivez-nous à support@studiosoie.com.",
    "footer": "Réponses instantanées · 7 j/7",
    "demo_badge": "Maquette · réponses simulées",
    "a_delivery": "France : 4 à 7 jours ouvrés. Union européenne : 5 à 8 jours ouvrés. Reste du monde : 7 à 12 jours ouvrés. Le numéro de suivi vous est envoyé par e-mail dès l'expédition.",
    "a_care": "Lavage à la main ou en machine à 30 °C, cycle délicat, dans un filet, avec une lessive spéciale soie. Pas de sèche-linge : séchage à plat à l'ombre. Repassage doux sur l'envers, légèrement humide.",
    "a_sizes": "Taies : 50×70 et 65×65 cm. Housses de couette : 140×200, 200×200, 240×220 cm. Pour les vêtements, chaque fiche produit indique les mesures à plat ; en cas de doute entre deux tailles, prenez la plus grande pour un tombé fluide.",
    "a_momme": "Le momme mesure la densité de la soie. 16 momme : léger et aérien. 19 momme : l'équilibre douceur, tenue et longévité — notre référence. 22 momme : plus dense, plus lourd, un lustre profond pour une literie d'exception.",
    "a_generic": "Merci pour votre question. Je vous réponds dans un instant — et si vous préférez, poursuivons par e-mail pour garder une trace écrite.",
    "source_lang": "fr"
  };
  /* Les textes émis par Liquid (filtre t) arrivent HTML-échappés (l'apostrophe devient &#39;) : on les décode une fois */
  function decodeEntities(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; var ta = document.createElement('textarea'); ta.innerHTML = s; return ta.value; }
  function buildDict(lang) {
    var raw = (window.SS_CHAT_I18N || {})[lang] || {}, emitted = {}, d;
    Object.keys(raw).forEach(function (k) { emitted[k] = decodeEntities(raw[k]); });
    if (lang === 'fr') d = Object.assign({}, EN, FR, emitted);
    else if (emitted.source_lang === lang) d = Object.assign({}, EN, emitted);
    else { d = Object.assign({}, EN); Object.keys(emitted).forEach(function (k) { if (k !== 'source_lang' && emitted[k] && emitted[k] !== FR[k]) d[k] = emitted[k]; }); }
    return d;
  }
  var PCT = { credit1: 45, cash1: 30, credit2: 75, cash2: 50, creditDmg: 115, cashDmg: 50 };
  var INTL = { fr: 'fr-FR', en: 'en-GB', de: 'de-DE', it: 'it-IT', es: 'es-ES', nl: 'nl-NL' };
  var EU = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
  var INTIMATE = /culotte|string|tanga|slip|brief|panty|panties|bas de lingerie|body\b|bodysuit|boxer/i;

  var SVG = {
    thread: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="M4 18c3-8 6-8 8-4s5 4 8-4"/><path d="M4 12c3-6 6-6 8-2s5 2 8-4"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
    home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l16-8-6 16-2.5-6.5L4 12z"/></svg>',
    camera: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>'
  };

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function fmt(s, vars) { return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return vars && vars[k] != null ? vars[k] : ''; }); }
  function pickLang(code) { return String(code || 'en').toLowerCase().slice(0, 2) || 'en'; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function regionOf(cc) { cc = (cc || '').toUpperCase(); if (cc === 'FR' || cc === 'MC') return 'fr'; return EU.indexOf(cc) >= 0 ? 'eu' : 'intl'; }
  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        var max = 1200, w = img.width, h = img.height;
        if (w > max || h > max) { var r = Math.min(max / w, max / h); w = Math.round(w * r); h = Math.round(h * r); }
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(img.src);
        resolve(c.toDataURL('image/jpeg', 0.75).split(',')[1]);
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });
  }

  /* ---------------- Transport démo (maquette) ---------------- */
  function DemoTransport(chat) { this.chat = chat; }
  DemoTransport.prototype.session = function () { return Promise.resolve({ sessionId: 'demo' }); };
  DemoTransport.prototype.lookupOrder = function (num, email) {
    var n = String(num || '').trim().toUpperCase().replace(/^#/, '');
    if (!/^STUDS-\d{4,6}$/.test(n) || !/@/.test(email || '')) return wait(700).then(function () { return { found: false }; });
    var last = n.slice(-1), now = Date.now(), day = 864e5;
    var status = last === '0' ? 'delivered' : (parseInt(last, 10) % 2 === 0 ? 'in_transit' : 'unfulfilled');
    var order = {
      name: n, createdAt: new Date(now - (status === 'unfulfilled' ? 2 : 6) * day).toISOString(), status: status,
      country: 'FR', region: 'fr', currency: 'EUR', total: 81.9,
      lineItems: [
        { id: 'li1', title: "Taie d'Oreiller en Soie de Mûrier 22 Momme", variant: 'Ivoire · 50×70 cm', qty: 1, price: 59 },
        { id: 'li2', title: 'Chouchou en Soie', variant: 'Champagne', qty: 1, price: 19 }
      ],
      tracking: status === 'unfulfilled' ? null : { number: '6A20431907512', company: 'Colissimo', lastStatus: status === 'delivered' ? 'Delivered · Lyon' : 'In transit · Hub Paris' }
    };
    return wait(900).then(function () { return { found: true, order: order }; });
  };
  DemoTransport.prototype.ask = function (text) {
    var t = this.chat.t, q = String(text).toLowerCase(), key = 'a_generic';
    if (/livr|deliver|liefer|consegn|entreg|lever|délai|delay|zeit|tempi|plazo|tijd/.test(q)) key = 'a_delivery';
    else if (/entret|lav|wash|care|pfleg|wasch|cura|cuid|onderh|repass|iron/.test(q)) key = 'a_care';
    else if (/taille|size|größe|grösse|taglia|talla|maat|dimension/.test(q)) key = 'a_sizes';
    else if (/momme|mm\b|19|22|16|densit/.test(q)) key = 'a_momme';
    return wait(800).then(function () { return { reply: t(key) }; });
  };
  DemoTransport.prototype.createCase = function (p) {
    var code = /^credit/.test(p.type) ? 'SS-AVOIR-' + Math.random().toString(36).slice(2, 6).toUpperCase() : null;
    return wait(900).then(function () { return { ok: true, caseId: 'C-' + Date.now().toString(36).toUpperCase(), code: code, applied: true }; });
  };
  DemoTransport.prototype.updateAddress = function () { return wait(800).then(function () { return { ok: true, applied: true }; }); };
  DemoTransport.prototype.cancelOrder = function () { return wait(800).then(function () { return { ok: true, applied: true }; }); };
  DemoTransport.prototype.handoff = function () { return wait(600).then(function () { return { ok: true }; }); };

  /* ---------------- Transport HTTP (production → Worker) ---------------- */
  function HttpTransport(chat) { this.chat = chat; this.base = String(chat.opts.endpoint || '').replace(/\/+$/, ''); this.sessionId = null; this.turnstileToken = null; }
  HttpTransport.prototype.post = function (path, body) {
    var self = this;
    body = body || {}; if (self.sessionId) body.sessionId = self.sessionId;
    return fetch(self.base + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  };
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(true);
    if (loadTurnstile.p) return loadTurnstile.p;
    loadTurnstile.p = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; s.async = true; s.defer = true;
      s.onload = function () { resolve(!!window.turnstile); }; s.onerror = function () { resolve(false); };
      document.head.appendChild(s);
      setTimeout(function () { resolve(!!window.turnstile); }, 8000);
    });
    return loadTurnstile.p;
  }
  HttpTransport.prototype.turnstile = function () {
    var key = this.chat.opts.turnstileSiteKey;
    if (!key) return Promise.resolve(null);
    return loadTurnstile().then(function (ok) { return ok ? renderTurnstile(key) : null; });
  };
  function renderTurnstile(key) {
    var host = document.createElement('div'); document.body.appendChild(host);
    return new Promise(function (resolve) {
      try {
        window.turnstile.render(host, { sitekey: key, size: 'invisible', callback: function (tok) { resolve(tok); setTimeout(function () { host.remove(); }, 1000); }, 'error-callback': function () { resolve(null); host.remove(); } });
      } catch (e) { resolve(null); host.remove(); }
      setTimeout(function () { resolve(null); }, 10000);
    });
  }
  HttpTransport.prototype.session = function () {
    var self = this; if (self.sessionId) return Promise.resolve({ sessionId: self.sessionId });
    return self.turnstile().then(function (tok) {
      return self.post('/v1/session', { locale: self.chat.lang, page: location.href, customer: self.chat.opts.customer || null, turnstileToken: tok });
    }).then(function (r) { self.sessionId = r.sessionId; return r; });
  };
  HttpTransport.prototype.lookupOrder = function (num, email) { var s = this; return s.session().then(function () { return s.post('/v1/order', { orderNumber: num, email: email }); }); };
  HttpTransport.prototype.ask = function (text, door) { var s = this; return s.session().then(function () { return s.post('/v1/message', { text: text, door: door || null }); }); };
  /* v2.2 : réponse en streaming (SSE) — les premiers mots s'affichent dès qu'ils sont générés ; onDelta(morceau) à chaque fragment, résultat final = { reply, escalated, degraded }.
     Repli automatique sur la réponse JSON classique si le navigateur ne lit pas les flux ou si le Worker ne streame pas. */
  HttpTransport.prototype.askStream = function (text, door, onDelta) {
    var s = this;
    if (!window.ReadableStream || !window.TextDecoder || !window.fetch) return s.ask(text, door);
    return s.session().then(function () {
      return fetch(s.base + '/v1/message', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ sessionId: s.sessionId, text: text, door: door || null, stream: true }), credentials: 'omit' });
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      if ((r.headers.get('Content-Type') || '').indexOf('text/event-stream') < 0 || !r.body) return r.json();
      var reader = r.body.getReader(), dec = new TextDecoder(), buf = '', done = null, err = null;
      function handle(chunk) {
        var m = /^event: (\w+)\ndata: ([\s\S]*)$/.exec(chunk); if (!m) return;
        var data; try { data = JSON.parse(m[2]); } catch (e) { return; }
        if (m[1] === 'delta') { if (onDelta && data.t) onDelta(data.t); }
        else if (m[1] === 'done') done = data;
        else if (m[1] === 'error') err = data.error || 'error';
      }
      function pump() {
        return reader.read().then(function (res) {
          if (res.done) { if (buf.trim()) handle(buf.trim()); if (err) throw new Error(err); if (!done) throw new Error('stream_incomplete'); return done; }
          buf += dec.decode(res.value, { stream: true });
          var idx; while ((idx = buf.indexOf('\n\n')) >= 0) { handle(buf.slice(0, idx)); buf = buf.slice(idx + 2); }
          return pump();
        });
      }
      return pump();
    });
  };
  HttpTransport.prototype.createCase = function (p) { var s = this; return s.session().then(function () { return s.post('/v1/case', p); }); };
  HttpTransport.prototype.updateAddress = function (address) { var s = this; return s.session().then(function () { return s.post('/v1/address', { address: address }); }); };
  HttpTransport.prototype.cancelOrder = function () { var s = this; return s.session().then(function () { return s.post('/v1/cancel', {}); }); };
  HttpTransport.prototype.handoff = function (email, transcript) { var s = this; return s.session().then(function () { return s.post('/v1/handoff', { email: email, transcript: transcript }); }); };

  /* ---------------- Widget ---------------- */
  function SSChat(opts) {
    var self = this;
    self.opts = Object.assign({ locale: 'fr', transport: 'demo', endpoint: '', turnstileSiteKey: '', customer: null, mount: document.body, autoOpen: false, demoBadge: false }, opts || {});
    self.lang = pickLang(self.opts.locale);
    self.dict = buildDict(self.lang);
    self.t = function (k) { var v = self.dict[k]; if (v == null) v = EN[k]; return v == null ? k : v; };
    self.transport = self.opts.transport === 'http' ? new HttpTransport(self) : new DemoTransport(self);
    self.state = { door: null, order: null, round: 0, declined: [], item: null, reason: null, photos: {}, awaiting: null, pendingType: null, open: false, busy: false };
    self.transcript = [];
    self.build();
    if (self.opts.autoOpen) self.open();
  }

  SSChat.prototype.money = function (amount, currency) {
    try { return new Intl.NumberFormat(INTL[this.lang] || this.opts.locale || 'fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(amount); }
    catch (e) { return amount.toFixed(2) + ' ' + (currency || 'EUR'); }
  };
  SSChat.prototype.date = function (iso) {
    try { return new Intl.DateTimeFormat(INTL[this.lang] || this.opts.locale || 'fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(iso)); } catch (e) { return iso; }
  };

  SSChat.prototype.build = function () {
    var self = this, t = self.t;
    var root = el('div', 'ssc-root');
    var o = self.opts.offsets || {};
    if (o.right != null) root.style.setProperty('--ssc-right', o.right + 'px');
    if (o.bottom != null) root.style.setProperty('--ssc-bottom', o.bottom + 'px');
    if (o.rightMobile != null) root.style.setProperty('--ssc-right-m', o.rightMobile + 'px');
    if (o.bottomMobile != null) root.style.setProperty('--ssc-bottom-m', o.bottomMobile + 'px');
    if (self.opts.hideMobile) root.classList.add('is-desktop-only');
    root.innerHTML =
      '<button type="button" class="ssc-launcher" aria-haspopup="dialog" aria-expanded="false">' + SVG.thread + '<span>' + esc(t('launcher')) + '</span><i class="ssc-dot" aria-hidden="true"></i></button>' +
      '<section class="ssc-panel" role="dialog" aria-modal="false" aria-label="' + esc(t('title')) + ' — ' + esc(t('subtitle')) + '">' +
        '<header class="ssc-head">' +
          '<button type="button" class="ssc-ico ssc-back" aria-label="' + esc(t('back')) + '" hidden>' + SVG.back + '</button>' +
          '<div class="ssc-brand"><b class="ssc-serif">' + esc(t('title')) + '</b><small>' + esc(t('subtitle')) + '</small>' + (self.opts.demoBadge ? '<span class="ssc-demo">' + esc(t('demo_badge')) + '</span>' : '') + '</div>' +
          '<button type="button" class="ssc-ico ssc-close" aria-label="' + esc(t('close')) + '">' + SVG.close + '</button>' +
        '</header>' +
        '<div class="ssc-body" aria-live="polite"></div>' +
        '<footer class="ssc-foot">' +
          '<div class="ssc-input"><textarea rows="1" placeholder="' + esc(t('input_ph')) + '" aria-label="' + esc(t('input_ph')) + '"></textarea><button type="button" class="ssc-send" aria-label="' + esc(t('send')) + '">' + SVG.send + '</button></div>' +
          '<div class="ssc-meta"><span>' + esc(t('footer')) + '</span><button type="button" class="ssc-fallback">' + esc(t('email_fallback')) + '</button></div>' +
        '</footer>' +
      '</section>';
    self.root = root;
    self.$ = function (s) { return root.querySelector(s); };
    self.body = self.$('.ssc-body');
    self.$('.ssc-launcher').addEventListener('click', function () { self.open(); });
    self.$('.ssc-close').addEventListener('click', function () { self.close(); });
    self.$('.ssc-back').addEventListener('click', function () { self.home(); });
    self.$('.ssc-fallback').addEventListener('click', function () { self.emailFallback(); });
    var ta = self.$('textarea');
    ta.addEventListener('input', function () { ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 96) + 'px'; });
    ta.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); self.sendTyped(); } });
    self.$('.ssc-send').addEventListener('click', function () { self.sendTyped(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.state.open) self.close(); });
    (self.opts.mount || document.body).appendChild(root);
    self.home();
  };

  SSChat.prototype.open = function () { this.state.open = true; this.root.classList.add('is-open'); document.documentElement.classList.add('ssc-lock'); this.$('.ssc-launcher').setAttribute('aria-expanded', 'true'); var c = this.$('.ssc-close'); setTimeout(function () { c.focus(); }, 300); if (this.opts.onOpen) this.opts.onOpen(); };
  SSChat.prototype.close = function () { this.state.open = false; this.root.classList.remove('is-open'); document.documentElement.classList.remove('ssc-lock'); this.$('.ssc-launcher').setAttribute('aria-expanded', 'false'); this.$('.ssc-launcher').focus(); };
  SSChat.prototype.destroy = function () { if (this.root && this.root.parentNode) this.root.parentNode.removeChild(this.root); };

  /* --- primitives d'affichage --- */
  SSChat.prototype.append = function (node) { this.body.appendChild(node); this.body.scrollTop = this.body.scrollHeight; return node; };
  SSChat.prototype.bot = function (html, lead) {
    var m = el('div', 'ssc-msg bot', (lead ? '<div class="ssc-lead">' + esc(lead) + '</div>' : '') + '<p>' + html + '</p>');
    this.transcript.push({ role: 'assistant', text: (lead ? lead + ' — ' : '') + m.textContent.trim() });
    return this.append(m);
  };
  SSChat.prototype.user = function (text) { this.transcript.push({ role: 'user', text: text }); return this.append(el('div', 'ssc-msg user', esc(text))); };
  SSChat.prototype.notice = function (text) { return this.append(el('div', 'ssc-notice', esc(text))); };
  SSChat.prototype.typing = function (on) {
    var ex = this.body.querySelector('.ssc-typing'); if (ex) ex.remove();
    if (on) { var n = el('div', 'ssc-typing', '<i></i><i></i><i></i><span class="ssc-sr">' + esc(this.t('typing')) + '</span>'); this.append(n); }
  };
  SSChat.prototype.clearChoices = function () { this.body.querySelectorAll('.ssc-chips, .ssc-form, .ssc-doors, .ssc-offers, .ssc-linkline, .ssc-items-pick').forEach(function (n) { n.remove(); }); };
  SSChat.prototype.chips = function (items, opts) {
    var self = this, wrap = el('div', 'ssc-chips');
    items.forEach(function (it) {
      var b = el('button', 'ssc-chip' + (it.primary ? ' primary' : '') + (it.ghost ? ' ghost' : ''), esc(it.label)); b.type = 'button';
      b.addEventListener('click', function () { if (self.state.busy) return; self.clearChoices(); if (!(opts && opts.silent)) self.user(it.label); it.onPick(); });
      wrap.appendChild(b);
    });
    return self.append(wrap);
  };
  SSChat.prototype.setBack = function (show) { var b = this.$('.ssc-back'); b.hidden = !show; };

  /* --- Accueil : trois portes --- */
  SSChat.prototype.home = function () {
    var self = this, t = self.t;
    self.clearChoices(); self.state.door = null; self.state.awaiting = null; self.setBack(false);
    if (!self.body.children.length) self.bot(esc(t('greeting')));
    var doors = el('div', 'ssc-doors');
    [['order', 'door_order_t', 'door_order_d'], ['problem', 'door_problem_t', 'door_problem_d'], ['question', 'door_question_t', 'door_question_d']].forEach(function (d) {
      var b = el('button', 'ssc-door', '<span><b>' + esc(t(d[1])) + '</b><small>' + esc(t(d[2])) + '</small></span>' + SVG.arrow); b.type = 'button';
      b.addEventListener('click', function () { self.clearChoices(); self.user(t(d[1])); self.enter(d[0]); });
      doors.appendChild(b);
    });
    self.append(doors);
  };
  SSChat.prototype.enter = function (door) {
    this.state.door = door; this.setBack(true);
    if (door === 'order') return this.doorOrder();
    if (door === 'problem') return this.doorProblem();
    return this.doorQuestion();
  };

  /* --- Porte 1 : ma commande --- */
  SSChat.prototype.doorOrder = function () { if (this.state.order) { this.orderCard(); this.orderActions(); } else this.orderForm(function () { this.orderCard(); this.orderActions(); }); };
  SSChat.prototype.orderForm = function (next) {
    var self = this, t = self.t, c = self.opts.customer || {};
    self.bot(esc(t('order_prompt')));
    var f = el('form', 'ssc-form',
      '<div><label>' + esc(t('order_label')) + '</label><input name="order" autocomplete="off" inputmode="text" placeholder="' + esc(t('order_ph')) + '" value="' + esc(c.lastOrder || '') + '"></div>' +
      '<div><label>' + esc(t('email_label')) + '</label><input name="email" type="email" autocomplete="email" placeholder="' + esc(t('email_ph')) + '" value="' + esc(c.email || '') + '"></div>' +
      '<div class="ssc-err"></div><div class="ssc-row"><button type="submit" class="ssc-btn">' + esc(t('continue')) + '</button></div>');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = f.order.value.trim(), email = f.email.value.trim();
      if (!num || !/@/.test(email)) { f.querySelector('.ssc-err').textContent = t('order_notfound'); return; }
      f.querySelector('button').disabled = true; f.querySelector('button').textContent = t('verifying');
      self.state.busy = true; self.typing(true);
      self.transport.lookupOrder(num, email).then(function (r) {
        self.typing(false); self.state.busy = false; f.remove();
        self.user(num + ' · ' + email);
        if (!r.found) { self.bot(esc(t('order_notfound'))); self.orderForm(next); return; }
        var o = r.order; o.region = o.region || regionOf(o.country); o.lineItems = o.lineItems || [];
        o.lineItems.forEach(function (li) { li.intimate = li.intimate != null ? li.intimate : INTIMATE.test(li.title + ' ' + (li.variant || '')); });
        self.state.order = o; self.state.email = email;
        self.bot(esc(t('order_found')));
        next.call(self);
      }).catch(function () { self.typing(false); self.state.busy = false; f.querySelector('button').disabled = false; f.querySelector('button').textContent = t('continue'); f.querySelector('.ssc-err').textContent = t('error'); });
    });
    self.append(f); setTimeout(function () { f.querySelector('input[name=order]').focus(); }, 50);
  };
  SSChat.prototype.statusLabel = function (o) { var t = this.t; return { unfulfilled: t('status_unfulfilled'), in_transit: t('status_intransit'), delivered: t('status_delivered'), fulfilled: t('status_fulfilled'), cancelled: t('status_cancelled') }[o.status] || t('status_fulfilled'); };
  SSChat.prototype.eta = function (o) { return this.t('eta_' + (o.region || 'eu')); };
  SSChat.prototype.trackUrl = function (o) { return o.tracking && o.tracking.url ? o.tracking.url : 'https://www.17track.net/' + this.lang + '#nums=' + encodeURIComponent(o.tracking ? o.tracking.number : ''); };
  SSChat.prototype.orderCard = function () {
    var self = this, t = self.t, o = self.state.order;
    var items = o.lineItems.map(function (li) {
      return '<div class="ssc-item"><div class="ssc-thumb"' + (li.image ? ' style="background:url(' + esc(li.image) + ') center/cover"' : '') + '></div><div>' + esc(li.title) + '<small>' + esc(li.variant || '') + (li.qty > 1 ? ' × ' + li.qty : '') + '</small></div><div class="ssc-price">' + esc(self.money(li.price * li.qty, o.currency)) + '</div></div>';
    }).join('');
    var card = el('div', 'ssc-card',
      '<div class="ssc-card-head"><b>' + esc(o.name) + '</b><span class="ssc-status' + (o.status === 'delivered' ? ' ok' : '') + '">' + esc(self.statusLabel(o)) + '</span></div>' +
      '<dl class="ssc-kv"><dt>' + esc(t('placed_on')) + '</dt><dd>' + esc(self.date(o.createdAt)) + '</dd>' +
      (o.tracking ? '<dt>' + esc(t('tracking')) + '</dt><dd>' + esc(o.tracking.number) + (o.tracking.company ? ' · ' + esc(o.tracking.company) : '') + '</dd>' : '') +
      '<dt>' + esc(t('eta')) + '</dt><dd>' + esc(self.eta(o)) + '</dd>' +
      '<dt>' + esc(t('total')) + '</dt><dd>' + esc(self.money(o.total, o.currency)) + '</dd></dl>' +
      '<div class="ssc-items">' + items + '</div>' +
      (o.tracking ? '<div class="ssc-row" style="justify-content:flex-start"><a class="ssc-btn ghost" style="text-decoration:none" target="_blank" rel="noopener" href="' + esc(self.trackUrl(o)) + '">' + esc(t('track_link')) + '</a></div>' : ''));
    self.append(card);
  };
  SSChat.prototype.orderActions = function () {
    var self = this, t = self.t, o = self.state.order, editable = o.status === 'unfulfilled';
    var list = [{ label: t('act_where'), onPick: function () { self.whereIsMyParcel(); } }];
    if (editable) list.push({ label: t('act_address'), onPick: function () { self.changeAddress(); } }, { label: t('act_cancel'), onPick: function () { self.cancelOrder(); } });
    list.push({ label: t('act_problem'), onPick: function () { self.enter('problem'); } }, { label: t('act_other'), onPick: function () { self.enter('question'); } });
    self.chips(list);
  };
  SSChat.prototype.whereIsMyParcel = function () {
    var self = this, t = self.t, o = self.state.order;
    if (o.status === 'unfulfilled') { self.bot(esc(t('where_unfulfilled'))); return self.orderActions(); }
    if (o.status === 'delivered') {
      self.bot(esc(t('where_delivered')));
      return self.chips([{ label: t('not_received'), primary: true, onPick: function () { self.notReceived(); } }, { label: t('home'), ghost: true, onPick: function () { self.home(); } }]);
    }
    self.bot(esc(fmt(t('where_transit'), { status: o.tracking && o.tracking.lastStatus ? o.tracking.lastStatus : self.statusLabel(o), eta: self.eta(o) })) + (o.tracking ? ' <a target="_blank" rel="noopener" href="' + esc(self.trackUrl(o)) + '">' + esc(t('track_link')) + '</a>' : ''));
    self.orderActions();
  };
  SSChat.prototype.notReceived = function () {
    var self = this, t = self.t;
    self.state.busy = true; self.typing(true);
    self.transport.createCase({ type: 'not_received', order_number: self.state.order.name, customer_email: self.state.email, locale: self.lang, transcript: self.transcript.slice(-12) })
      .then(function (r) { self.typing(false); self.state.busy = false; self.bot(esc(r && r.blocked && r.message ? r.message : t('not_received_reply'))); self.chips([{ label: t('home'), ghost: true, onPick: function () { self.home(); } }]); })
      .catch(function () { self.fail(); });
  };
  SSChat.prototype.changeAddress = function () { var self = this; self.bot(esc(self.t('address_prompt'))); self.state.awaiting = 'address'; self.$('textarea').focus(); };
  SSChat.prototype.applyAddress = function (text) {
    var self = this, t = self.t;
    self.state.awaiting = null; self.state.busy = true; self.typing(true);
    self.transport.updateAddress(text).then(function (r) {
      self.typing(false); self.state.busy = false;
      self.bot(esc(t(r.applied ? 'address_ok' : 'address_pending'))); self.orderActions();
    }).catch(function () { self.fail(); });
  };
  SSChat.prototype.cancelOrder = function () {
    var self = this, t = self.t;
    if (self.state.order.status !== 'unfulfilled') { self.bot(esc(t('cancel_late'))); return self.orderActions(); }
    self.bot(esc(t('cancel_ask')));
    self.chips([
      { label: t('cancel_yes'), primary: true, onPick: function () {
        self.state.busy = true; self.typing(true);
        self.transport.cancelOrder().then(function (r) { self.typing(false); self.state.busy = false; self.bot(esc(t(r.applied ? 'cancel_done' : 'cancel_pending'))); self.chips([{ label: t('home'), ghost: true, onPick: function () { self.home(); } }]); }).catch(function () { self.fail(); });
      } },
      { label: t('cancel_no'), onPick: function () { self.bot(esc(t('cancel_kept'))); self.orderActions(); } }
    ]);
  };

  /* --- Porte 2 : un problème --- */
  SSChat.prototype.doorProblem = function () {
    var self = this;
    if (!self.state.order) return self.orderForm(function () { self.orderCard(); self.pickItem(); });
    self.pickItem();
  };
  SSChat.prototype.pickItem = function () {
    var self = this, t = self.t, o = self.state.order;
    self.state.round = 0; self.state.declined = []; self.state.photos = {};
    self.bot(esc(t('problem_item')));
    var wrap = el('div', 'ssc-doors ssc-items-pick');
    o.lineItems.forEach(function (li) {
      var b = el('button', 'ssc-item-btn', '<div class="ssc-thumb"' + (li.image ? ' style="background:url(' + esc(li.image) + ') center/cover"' : '') + '></div><div>' + esc(li.title) + '<small>' + esc(li.variant || '') + '</small></div>'); b.type = 'button';
      b.addEventListener('click', function () { self.clearChoices(); self.user(li.title); self.state.item = li; self.pickReason(); });
      wrap.appendChild(b);
    });
    self.append(wrap);
  };
  SSChat.prototype.pickReason = function () {
    var self = this, t = self.t;
    self.bot(esc(t('problem_reason')));
    var reasons = ['size_small', 'size_big', 'not_liked', 'quality', 'damaged', 'not_as_described', 'wrong_item', 'missing', 'other'];
    self.chips(reasons.map(function (r) { return { label: t('r_' + r), onPick: function () { self.state.reason = r; self.routeReason(); } }; }));
  };
  SSChat.prototype.routeReason = function () {
    var self = this, r = self.state.reason;
    if (['damaged', 'not_as_described', 'wrong_item', 'missing'].indexOf(r) >= 0) return self.damagedFlow();
    if (self.state.item.intimate) { self.notice(self.t('intimates_notice')); return self.chips([{ label: self.t('act_other'), onPick: function () { self.enter('question'); } }, { label: self.t('home'), ghost: true, onPick: function () { self.home(); } }]); }
    self.offers(1);
  };
  SSChat.prototype.offerAmount = function (pct) { var li = this.state.item; return Math.round(li.price * li.qty * pct) / 100; };
  SSChat.prototype.offers = function (round) {
    var self = this, t = self.t, o = self.state.order;
    self.state.round = round;
    var credit = round === 1 ? PCT.credit1 : PCT.credit2, cash = round === 1 ? PCT.cash1 : PCT.cash2;
    self.bot(esc(t(round === 1 ? 'offer_sub' : 'offer2_sub')), t(round === 1 ? 'offer_title' : 'offer2_title'));
    var wrap = el('div', 'ssc-offers');
    wrap.innerHTML =
      '<div class="ssc-offer gold"><span class="ssc-badge">' + esc(t('best')) + '</span><h4>' + esc(t('credit_title')) + '</h4><div class="ssc-pct">' + esc(fmt(t('credit_line'), { pct: credit, amount: self.money(self.offerAmount(credit), o.currency) })) + '</div><div class="ssc-pts">' + esc(t('credit_pts')) + '</div><button type="button" class="ssc-btn" data-k="credit">' + esc(t('choose')) + '</button></div>' +
      '<div class="ssc-offer"><h4>' + esc(t('cash_title')) + '</h4><div class="ssc-pct">' + esc(fmt(t('cash_line'), { pct: cash, amount: self.money(self.offerAmount(cash), o.currency) })) + '</div><div class="ssc-pts">' + esc(t('cash_pts')) + '</div><button type="button" class="ssc-btn ghost" data-k="cash">' + esc(t('choose')) + '</button></div>';
    wrap.querySelector('[data-k=credit]').addEventListener('click', function () { self.clearChoices(); self.user(t('credit_title') + ' · ' + credit + ' %'); self.submitOffer('credit_' + credit, credit); });
    wrap.querySelector('[data-k=cash]').addEventListener('click', function () { self.clearChoices(); self.user(t('cash_title') + ' · ' + cash + ' %'); self.submitOffer('cash_' + cash, cash); });
    self.append(wrap);
    var link = el('div', 'ssc-linkline', '<button type="button">' + esc(t('keep_return')) + '</button>');
    link.querySelector('button').addEventListener('click', function () {
      self.clearChoices(); self.user(t('keep_return'));
      self.state.declined.push((round === 1 ? 'avoir ' : 'avoir2 ') + credit + '% / cash ' + cash + '%');
      if (round === 1) self.offers(2); else self.returnFlow();
    });
    self.append(link);
  };
  SSChat.prototype.casePayload = function (type, pct, extra) {
    var s = this.state, o = s.order;
    return Object.assign({
      type: type, request_type: type, order_number: o.name, customer_email: s.email, locale: this.lang,
      item_id: s.item ? s.item.id : null, items: s.item ? s.item.title + (s.item.variant ? ' — ' + s.item.variant : '') : '',
      reason: s.reason ? this.t('r_' + s.reason) : '', reason_code: s.reason || '', offer_pct: pct || 0,
      amount: pct ? this.offerAmount(pct) : 0, currency: o.currency,
      offers_declined: s.declined.join(' | ') || '-', intimates_ack: 'oui', free_label_requested: 'non',
      submitted_at: new Date().toISOString(), source: 'chat', transcript: this.transcript.slice(-16)
    }, extra || {});
  };
  SSChat.prototype.submitOffer = function (type, pct) {
    var self = this, t = self.t, o = self.state.order, amount = self.money(self.offerAmount(pct), o.currency);
    self.state.busy = true; self.typing(true);
    self.transport.createCase(self.casePayload(type, pct)).then(function (r) {
      self.typing(false); self.state.busy = false;
      // v2 : le serveur peut refuser (geste déjà accordé, dossier ouvert, revue humaine) → il renvoie un message déjà traduit
      if (r && r.blocked && r.message) self.bot(esc(r.message));
      else if (/^credit/.test(type)) self.bot(esc(r.code ? fmt(t('credit_done'), { amount: amount, code: r.code }) : fmt(t('credit_pending'), { amount: amount })));
      else self.bot(esc(fmt(t('cash_done'), { amount: amount })));
      self.chips([{ label: t('home'), ghost: true, onPick: function () { self.home(); } }]);
    }).catch(function () { self.fail(); });
  };
  SSChat.prototype.damagedFlow = function () {
    var self = this, t = self.t;
    self.bot(esc(t('damaged_sub')), t('damaged_title'));
    self.photosForm(false, function (photos, comment) {
      self.submitCase(self.casePayload('damaged_claim', 0, { photo_product: photos.photo_product, photo_packaging: photos.photo_packaging, photo_label: photos.photo_label, comment: comment }), fmt(t('damaged_sent'), { creditDmg: PCT.creditDmg, cashDmg: PCT.cashDmg }));
    });
  };
  SSChat.prototype.returnFlow = function () {
    var self = this, t = self.t;
    self.bot(esc(t('return_warn')), t('return_title'));
    self.photosForm(true, function (photos, comment) {
      self.submitCase(self.casePayload('return_shipment', 0, { photo_product: photos.photo_product, photo_packaging: photos.photo_packaging, photo_label: photos.photo_label, comment: comment }), t('return_sent'));
    });
  };
  SSChat.prototype.photosForm = function (isReturn, onSubmit) {
    var self = this, t = self.t, photos = {};
    var f = el('form', 'ssc-form');
    f.innerHTML = '<div style="font-size:12.5px;color:var(--ssc-muted)">' + esc(t('photos_intro')) + '</div><div class="ssc-photos"></div>' +
      '<div><label>' + esc(t('comment_label')) + '</label><textarea name="comment" placeholder="' + esc(t('comment_ph')) + '"></textarea></div>' +
      '<div class="ssc-err"></div><div class="ssc-row"><button type="submit" class="ssc-btn">' + esc(t('send')) + '</button></div>';
    var grid = f.querySelector('.ssc-photos');
    [['photo_product', t('photo_product')], ['photo_packaging', t('photo_packaging')], ['photo_label', t('photo_label')]].forEach(function (p) {
      var slot = el('label', 'ssc-photo', SVG.camera + '<span><b>' + esc(p[1]) + '</b><br>' + esc(t('add_photo')) + '</span><img alt=""><input type="file" accept="image/*" capture="environment">');
      slot.querySelector('input').addEventListener('change', function (ev) {
        var file = ev.target.files[0]; if (!file) return;
        shrink(file).then(function (b64) { photos[p[0]] = b64; slot.querySelector('img').src = 'data:image/jpeg;base64,' + b64; slot.classList.add('has'); });
      });
      grid.appendChild(slot);
    });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!photos.photo_product || !photos.photo_packaging || !photos.photo_label) { f.querySelector('.ssc-err').textContent = t('photos_missing'); return; }
      var btn = f.querySelector('button[type=submit]'); btn.disabled = true;
      var comment = f.comment.value.trim(); f.remove(); self.user(t('send') + ' · 3 📷' + (comment ? ' · ' + comment : ''));
      onSubmit(photos, comment);
    });
    self.append(f);
  };
  SSChat.prototype.submitCase = function (payload, doneText) {
    var self = this, t = self.t;
    self.state.busy = true; self.typing(true);
    self.transport.createCase(payload).then(function (r) {
      self.typing(false); self.state.busy = false; self.bot(esc(r && r.blocked && r.message ? r.message : doneText));
      self.chips([{ label: t('home'), ghost: true, onPick: function () { self.home(); } }]);
    }).catch(function () { self.fail(); });
  };

  /* --- Porte 3 : une question --- */
  SSChat.prototype.doorQuestion = function () {
    var self = this, t = self.t;
    self.bot(esc(t('question_prompt')));
    self.chips(['q_delivery', 'q_care', 'q_sizes', 'q_momme'].map(function (k) { return { label: t(k), onPick: function () { self.ask(t(k)); } }; }));
    self.$('textarea').focus();
  };
  function fmtReply(s) { return esc(s).replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br>'); }
  SSChat.prototype.ask = function (text) {
    var self = this, t = self.t, live = null, acc = '';
    self.state.busy = true; self.typing(true);
    // v2.2 : bulle « en direct » remplie au fil du flux, puis remplacée par la réponse finale (identique en pratique)
    var onDelta = function (chunk) {
      acc += chunk;
      if (!live) {
        if (!document.getElementById('ssc-live-style')) { var st = document.createElement('style'); st.id = 'ssc-live-style'; st.textContent = '.ssc-root .ssc-live p:after{content:"\\2590";display:inline-block;width:.45em;margin-left:2px;color:var(--ssc-gold);animation:sscBlink 1s steps(2) infinite}@media(prefers-reduced-motion:reduce){.ssc-root .ssc-live p:after{animation:none}}'; document.head.appendChild(st); }
        self.typing(false); live = self.append(el('div', 'ssc-msg bot ssc-live', '<p></p>'));
      }
      live.firstChild.innerHTML = fmtReply(acc); self.body.scrollTop = self.body.scrollHeight;
    };
    var p = self.transport.askStream ? self.transport.askStream(text, self.state.door, onDelta) : self.transport.ask(text, self.state.door);
    p.then(function (r) {
      self.typing(false); self.state.busy = false;
      var html = fmtReply((r && r.reply) || t('a_generic'));
      if (live) { live.classList.remove('ssc-live'); live.firstChild.innerHTML = html; self.transcript.push({ role: 'assistant', text: live.textContent.trim() }); self.body.scrollTop = self.body.scrollHeight; }
      else self.bot(html);
      if (r && r.suggestions && r.suggestions.length) self.chips(r.suggestions.map(function (s) { return { label: s, onPick: function () { self.ask(s); } }; }));
    }).catch(function () { if (live) live.remove(); self.fail(); });
  };
  SSChat.prototype.sendTyped = function () {
    var self = this, ta = self.$('textarea'), text = ta.value.trim();
    if (!text || self.state.busy) return;
    ta.value = ''; ta.style.height = 'auto';
    self.clearChoices(); self.user(text);
    if (self.state.awaiting === 'address') return self.applyAddress(text);
    if (self.state.awaiting === 'email') return self.finishHandoff(text);
    if (!self.state.door) self.state.door = 'question';
    self.ask(text);
  };

  /* --- Repli e-mail --- */
  SSChat.prototype.emailFallback = function () {
    var self = this, t = self.t;
    self.clearChoices(); self.bot(esc(t('email_prompt')));
    if (self.state.email) return self.finishHandoff(self.state.email);
    self.state.awaiting = 'email'; self.$('textarea').focus();
  };
  SSChat.prototype.finishHandoff = function (email) {
    var self = this, t = self.t;
    if (!/@/.test(email)) { self.bot(esc(t('email_prompt'))); self.state.awaiting = 'email'; return; }
    self.state.awaiting = null; self.state.busy = true; self.typing(true);
    self.transport.handoff(email, self.transcript).then(function () {
      self.typing(false); self.state.busy = false; self.bot(esc(fmt(t('email_done'), { email: email })));
      self.chips([{ label: t('home'), ghost: true, onPick: function () { self.home(); } }]);
    }).catch(function () { self.fail(); });
  };
  SSChat.prototype.fail = function () { var self = this; self.typing(false); self.state.busy = false; self.bot(esc(self.t('error'))); self.chips([{ label: self.t('home'), ghost: true, onPick: function () { self.home(); } }]); };

  SSChat.init = function (opts) { if (window.SSChatInstance) window.SSChatInstance.destroy(); window.SSChatInstance = new SSChat(opts); return window.SSChatInstance; };
  window.SSChat = SSChat;

  /* --- Démarrage automatique depuis la section Liquid --- */
  function boot() {
    var c = window.SS_CHAT_CONFIG;
    if (!c || window.SSChatInstance) return;
    var inst = SSChat.init(c);
    /* Ouverture par lien : <a href="#chat"> ou [data-ss-chat] (menu, page contact, footer…) */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#chat"], [data-ss-chat]');
      if (!a) return;
      e.preventDefault(); inst.open();
    });
    if (/(^|[?&])chat=open(&|$)/.test(location.search) || location.hash === '#chat' || c.autoOpen) setTimeout(function () { inst.open(); }, 600);
    /* Barre de prévisualisation Shopify (thèmes non publiés) : on remonte le widget de sa hauteur */
    function previewBar() { var f = document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe'); if (!f) return 0; var w = f.parentElement && f.parentElement.getAttribute('popover') != null ? f.parentElement : f; var h = w.getBoundingClientRect().height; return h > 0 && h < 160 ? h : 0; }
    function adjust() { var h = previewBar(), o = c.offsets || {}; inst.root.style.setProperty('--ssc-bottom', ((o.bottom != null ? o.bottom : 20) + h) + 'px'); inst.root.style.setProperty('--ssc-bottom-m', ((o.bottomMobile != null ? o.bottomMobile : 16) + h) + 'px'); }
    setTimeout(adjust, 1200); setTimeout(adjust, 4000); window.addEventListener('resize', adjust);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
